import { Fragment, useState, useEffect, useRef } from "react";
import { Props } from "./types";
import getConfig from "next/config";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { Share2Icon } from "lucide-react";

const PropertyShareButton = ({ listing }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isOpened, setShareButtonBlockOpened] = useState(false);
  const { publicRuntimeConfig } = getConfig();
  const wrapperRef = useRef(null);
  const url = `${publicRuntimeConfig.NEXT_PUBLIC_URL}/properties/${listing.district_code}/${listing.id}`;
  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShareButtonBlockOpened(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(url);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
  };

  useOutsideAlerter(wrapperRef);

  return (
    <Fragment>
      <div ref={wrapperRef} className="max-w-[50px]  relative">
        <div
          className="w-auto h-[33px] max-w-[30px] md:max-h-[50px] md:max-w-[50px] hover:cursor-pointer relative"
          onClick={() => setShareButtonBlockOpened(!isOpened)}
        >
          <Share2Icon stroke="#3D465B" />
        </div>
        <div
          className={`${
            isOpened ? "flex flex-col" : "hidden"
          } bg-grey-900 rounded-lg absolute top-14 text-left -left-[120px] lg:-left-[184px] text-white text-sm leading-[17px] tracking-[-1.1%] pl-5 pr-12 md:pr-24 py-2.5 z-10`}
        >
          <div
            className={`${
              isCopied ? "flex" : "hidden"
            } bg-landing-cherry rounded-lg absolute -top-8 left-0 text-white p-5 z-20 w-fit min-w-fit`}
          >
            Link copied
          </div>
          <div className="font-bold text-[10px] leading-[13px] pb-3">SHARE</div>
          <div
            className="pb-4 hover:cursor-pointer"
            onClick={() => {
              handleCopyClick();
            }}
          >
            Copy link
          </div>
          <div className="pb-4 w-max">
            <FacebookShareButton url={url}>Share on Facebook</FacebookShareButton>
          </div>
          <div className="pb-4">
            <TwitterShareButton url={url} title={listing.title} via="keyzyhomes">
              Share on Twitter
            </TwitterShareButton>
          </div>
          <div>
            <LinkedinShareButton
              url={url}
              summary={listing.short_description}
              title={listing.title}
            >
              Share on Linkedin
            </LinkedinShareButton>
          </div>
        </div>
        <div
          className={`z-10 origin-top-left ml-4 transform absolute rotate-45 bg-grey-900  w-8 h-8 ${
            isOpened ? "flex" : "hidden"
          }`}
        ></div>
      </div>
    </Fragment>
  );
};
export default PropertyShareButton;
